<template>
  <div>
    监测系统
  </div>
</template>

<script>
export default {
  name: 'ZuijiBridegIndex',

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>